import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Grid from '../../../baseComponents/Grid'
import HeaderGrid from '../../../baseComponents/HeaderGrid'
import Shape from '../../../baseComponents/Shape'

export const maxAnimationTime = {
  'template-1': 2500,
  'template-2': 500,
  'template-3': 2500,
  'template-4': 500,
  'template-5': 500,
}

const template = {
  'template-1': {
    6: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },
      { x: 4, y: 0, w: 1, h: 1, component: '', },
      { x: 5, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: '', },
      { x: 5, y: 1, w: 1, h: 1, component: '', },
      { x: 0, y: 2, w: 1, h: 1, component: '', },
      { x: 5, y: 2, w: 1, h: 1, component: '', },

      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1350 },
      { x: 4, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1150 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 4, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },
      { x: 4, y: 3, w: 1, h: 1, },
      { x: 5, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },
      { x: 4, y: 4, w: 1, h: 1, },
      { x: 5, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
      { x: 4, y: 5, w: 1, h: 1, },
      { x: 5, y: 5, w: 1, h: 1, },

    ],
    4: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1100 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1050 },
      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
    ],
    2: [
      { x: 0, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 0, w: 1, h: 1, component: 'Shape', value: 12, className: 'animated-home', time: 1250 },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 30, className: 'animated-home', time: 1300 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 31, className: 'animated-home', time: 1000 },

      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 19, axisX: 180, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: '', className: 'animated-home', time: 1450 },

      { x: 0, y: 3, w: 1, h: 1, component: '', className: 'animated-home', time: 1500 },
      { x: 1, y: 3, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 1200 },

      { x: 0, y: 4, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 4, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 500 },
      { x: 0, y: 5, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 5, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 6, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 6, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 7, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 7, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 8, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 8, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 9, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 9, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    ],
    1: [
      { x: 0, y: 0, w: 1, h: 1, component: 'Content', value: 1, axisX: 180, non: true },
    ]
  },
  'template-2': {
    6: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },
      { x: 4, y: 0, w: 1, h: 1, component: '', },
      { x: 5, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: '', },
      { x: 5, y: 1, w: 1, h: 1, component: '', },
      { x: 0, y: 2, w: 1, h: 1, component: '', },
      { x: 5, y: 2, w: 1, h: 1, component: '', },

      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1350 },
      { x: 4, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1150 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 4, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },
      { x: 4, y: 3, w: 1, h: 1, },
      { x: 5, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },
      { x: 4, y: 4, w: 1, h: 1, },
      { x: 5, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
      { x: 4, y: 5, w: 1, h: 1, },
      { x: 5, y: 5, w: 1, h: 1, },

    ],
    4: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1100 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1050 },
      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
    ],
    2: [
      { x: 0, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 0, w: 1, h: 1, component: 'Shape', value: 12, className: 'animated-home', time: 1250 },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 30, className: 'animated-home', time: 1300 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 31, className: 'animated-home', time: 1000 },

      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 19, axisX: 180, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: '', className: 'animated-home', time: 1450 },

      { x: 0, y: 3, w: 1, h: 1, component: '', className: 'animated-home', time: 1500 },
      { x: 1, y: 3, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 1200 },

      { x: 0, y: 4, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 4, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 500 },
      { x: 0, y: 5, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 5, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 6, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 6, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 7, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 7, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 8, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 8, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 9, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 9, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    ],
    1: [
      { x: 0, y: 0, w: 1, h: 1, component: 'Content', value: 1, axisX: 180, non: true },
    ]
  },
  'template-3': {
    6: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },
      { x: 4, y: 0, w: 1, h: 1, component: '', },
      { x: 5, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: '', },
      { x: 5, y: 1, w: 1, h: 1, component: '', },
      { x: 0, y: 2, w: 1, h: 1, component: '', },
      { x: 5, y: 2, w: 1, h: 1, component: '', },

      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1250 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1350 },
      { x: 4, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1150 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 4, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1150 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },
      { x: 4, y: 3, w: 1, h: 1, },
      { x: 5, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },
      { x: 4, y: 4, w: 1, h: 1, },
      { x: 5, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
      { x: 4, y: 5, w: 1, h: 1, },
      { x: 5, y: 5, w: 1, h: 1, },

    ],
    4: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1100 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1100 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1300 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1300 },
      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1150 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1300 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1300 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
    ],
    2: [
      { x: 0, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 0, w: 1, h: 1, component: 'Shape', value: 12, className: 'animated-home', time: 1250 },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 30, className: 'animated-home', time: 1300 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 31, className: 'animated-home', time: 1000 },

      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 19, axisX: 180, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: '', className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', className: 'animated-home', time: 1200 },
      { x: 1, y: 3, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 1200 },

      { x: 0, y: 4, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 4, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 500 },
      { x: 0, y: 5, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 5, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 6, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 6, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 7, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 7, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 8, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 8, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 9, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 9, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    ],
    1: [
      { x: 0, y: 0, w: 1, h: 1, component: 'Content', value: 1, axisX: 180, non: true },
    ]
  },
  'template-4': {
    6: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },
      { x: 4, y: 0, w: 1, h: 1, component: '', },
      { x: 5, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: '', },
      { x: 5, y: 1, w: 1, h: 1, component: '', },
      { x: 0, y: 2, w: 1, h: 1, component: '', },
      { x: 5, y: 2, w: 1, h: 1, component: '', },

      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1350 },
      { x: 4, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1150 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 4, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },
      { x: 4, y: 3, w: 1, h: 1, },
      { x: 5, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },
      { x: 4, y: 4, w: 1, h: 1, },
      { x: 5, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
      { x: 4, y: 5, w: 1, h: 1, },
      { x: 5, y: 5, w: 1, h: 1, },

    ],
    4: [
      { x: 0, y: 0, w: 1, h: 1, component: '', },
      { x: 1, y: 0, w: 1, h: 1, component: '', },
      { x: 2, y: 0, w: 1, h: 1, component: '', },
      { x: 3, y: 0, w: 1, h: 1, component: '', },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 22, className: 'animated-home', time: 1100 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 23, className: 'animated-home', time: 1250 },
      { x: 2, y: 1, w: 1, h: 1, component: 'Shape', value: 24, className: 'animated-home', time: 1150 },
      { x: 3, y: 1, w: 1, h: 1, component: 'Shape', value: 25, className: 'animated-home', time: 1050 },
      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 26, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: 'Shape', value: 27, className: 'animated-home', time: 1200 },
      { x: 2, y: 2, w: 1, h: 1, component: 'Shape', value: 28, className: 'animated-home', time: 1150 },
      { x: 3, y: 2, w: 1, h: 1, component: 'Shape', value: 29, className: 'animated-home', time: 1000 },

      { x: 0, y: 3, w: 1, h: 1, component: '', },
      { x: 1, y: 3, w: 1, h: 1, component: '', },
      { x: 2, y: 3, w: 1, h: 1, component: '', },
      { x: 3, y: 3, w: 1, h: 1, },

      { x: 0, y: 4, w: 1, h: 1, },
      { x: 1, y: 4, w: 1, h: 1, },
      { x: 2, y: 4, w: 1, h: 1, },
      { x: 3, y: 4, w: 1, h: 1, },

      { x: 0, y: 5, w: 1, h: 1, },
      { x: 1, y: 5, w: 1, h: 1, },
      { x: 2, y: 5, w: 1, h: 1, },
      { x: 3, y: 5, w: 1, h: 1, },
    ],
    2: [
      { x: 0, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 0, w: 1, h: 1, component: 'Shape', value: 12, className: 'animated-home', time: 1250 },

      { x: 0, y: 1, w: 1, h: 1, component: 'Shape', value: 30, className: 'animated-home', time: 1300 },
      { x: 1, y: 1, w: 1, h: 1, component: 'Shape', value: 31, className: 'animated-home', time: 1000 },

      { x: 0, y: 2, w: 1, h: 1, component: 'Shape', value: 19, axisX: 180, className: 'animated-home', time: 1300 },
      { x: 1, y: 2, w: 1, h: 1, component: '', className: 'animated-home', time: 1450 },

      { x: 0, y: 3, w: 1, h: 1, component: '', className: 'animated-home', time: 1500 },
      { x: 1, y: 3, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 1200 },

      { x: 0, y: 4, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 1, y: 4, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, className: 'animated-home', time: 500 },
      { x: 0, y: 5, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 5, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 6, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 6, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 7, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 7, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 8, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 8, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
      { x: 0, y: 9, w: 1, h: 1, component: 'Shape', value: 20, axisX: 180, non: false, className: 'animated-home', time: 500 },
      { x: 1, y: 9, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    ],
    1: [
      { x: 0, y: 0, w: 1, h: 1, component: 'Content', value: 1, axisX: 180, non: true },
    ]
  },
}

const headerTemplate = {
  6: [
    { x: 0, y: 0, w: 1, h: 1, component: '', },
    { x: 1, y: 0, w: 1, h: 1, component: '', },
    { x: 2, y: 0, w: 1, h: 1, component: '', },
    { x: 3, y: 0, w: 1, h: 1, component: '', },
  ],
  4: [
    { x: 0, y: 0, w: 1, h: 1, component: '', },
    { x: 1, y: 0, w: 1, h: 1, component: '', },
    { x: 2, y: 0, w: 1, h: 1, component: '', },
    { x: 3, y: 0, w: 1, h: 1, component: '', },
  ],
  2: [
    { x: 0, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    { x: 1, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    { x: 2, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
    { x: 3, y: 0, w: 1, h: 1, component: '', className: 'animated-home', time: 500 },
  ],
  1: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Content', value: 1, axisX: 180, non: true },
  ]
}


let getComponent = (component, props) => {
  if (component === null) return component
  switch (component) {
    case 'Logo': return <AnimatedBox {...props}><SomaLogo {...props} /></AnimatedBox>
    case 'Shape': return <AnimatedBox {...props}><Shape {...props} /></AnimatedBox>
    default: return null
  }
}

const Loading = props => {

  const [fade, setFade] = useState(false)
    , [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (!initialized) {
      setTimeout(() => {
        setFade(true)
        setInitialized(true)
      }, 100)
    }
  }, [initialized])

  return <div className='faded' style={{ height: `100${props.percent ? '%' : 'vh'}`, opacity: fade ? 1 : 0 }}>

    {
      props.appState.item === 2
        ? <HeaderGrid shouldHide={props.loading}>
          {
            headerTemplate[props.appState.item].map((item, index) => {
              return <div
                className={item.className ? item.className : ''}
                style={{ background: props.appState.colorTheme.base }}
                key={index} values={{ x: item.x, y: item.y, w: item.w, h: item.h, isResizable: false, static: true }}>
                {getComponent(item.component, { ...props, ...item })}
              </div>
            })
          }
        </HeaderGrid>
        : null
    }
    <Grid shouldHide={props.loading}>
      {
        template[props.template][props.appState.item].map((item, index) => {
          return <div
            className={item.className ? item.className : ''}
            style={{ background: props.appState.colorTheme.base }}
            key={index} values={{ x: item.x, y: item.y, w: item.w, h: item.h, isResizable: false, static: true }}>
            {getComponent(item.component, { ...props, ...item })}
          </div>
        })
      }
    </Grid>
  </div>
}


const SomaLogo = props => <div style={{ alignItems: 'center', display: 'flex', height: '100%', justifyContent: 'center', width: '100%' }}>
  <span style={{ width: '100%', height: 'auto', transform: `rotateY(${props.y}deg)` }} dangerouslySetInnerHTML={{
    __html: `
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 825.64 254.93"><defs><style>.cls-1{fill:${props.appState.colorTheme.level1};  }</style></defs><title>logo</title>
    <path class="cls-1" d="M1.59,166.23c-5.13,39.56,5.31,87.1,47,83.85,9.79-.77,17.1-5.41,23.51-10.06,4.65-3.38,10.14-7.69,12.09-12.75-3.27-1.17-7.75-.54-11.42-2-18.92-7.61-14-31.89-15.45-58.36-16.9-1.52-39.94-.29-55.76-.67m692.62-63.06c-34.84,4-41.25,52.38-37.62,93.91,2.65,30.37,22.18,61.45,55.08,51.65,11.15-3.31,18.9-10,27.54-20.12-3.5-1.35-8.26-1.34-12.09-3.35-14.85-7.8-13.43-25.11-13.43-50.31,0-10.7-.8-22.34,0-31.53,1.87-21.38,10.84-33.57,24.85-39.58-11.33-.37-32.15-2.08-44.33-.67M42.57,9.26C27.94,10.73,16.88,19.33,10.33,27.37,2.78,42.41-2.37,58.26,1.59,77c2.79,13.15,11.2,23.58,20.16,33.54,17.74,19.75,37.36,33,58.44,50.31,13.29,10.94,34.33,18.35,30.91,41.59-2.74,18.53-19.91,38.33-37.63,45.62-4.25,1.75-8.87,1.21-12.09,4.69,20.32,1.18,37.31,3.34,53.74.67,34.69-5.62,62-38.33,51.06-81.16-4.24-16.67-17.78-26.05-28.89-36.9-15.91-15.56-31.86-26.81-49-39.58-13-9.69-26.33-16-32.24-30.18C47.13,44.27,65.34,26.06,77.5,20.66,70.44,12.19,56.67,7.84,42.57,9.26m653-2.69c-31,3.83-42.3,41.53-38.29,79.16C672,88,694.85,86,713,86.4c2.52-12.41-1.08-24.63.67-35.55C716,36.73,727,31.64,739.89,28c-11.45-9.63-23.36-24-44.34-21.47m-202.21,4.7C459.15,31,468.48,99.7,468.48,156.16v97.27c16.52,2.73,39.17,1.13,56.44,0V104.51c0-36.33-6-73.92,26.19-75.8-8.65-14.34-36.76-29.56-57.77-17.44m-80.61-4c-41.71,11.67-37,60.18-37,114.7,0,48.14-.54,95.39.67,131.48,17.05-1.82,39-.48,56.3-1.58,1.21-45,.8-103.21.8-153.38,0-17.75-2.84-36.59,0-49.63,2.38-10.91,14.42-19.21,25.53-20.13-9.41-10.14-26.77-26.95-46.35-21.46m-199.52,4c-30.61,17-24.86,66.32-24.86,116.72,0,24.15-1.42,49,0,67.75,2,26.12,14,49,33.59,53.67,17.19,4.06,30.93-4.23,39.64-10.73,4-3,8.79-6.21,10.07-10.74-12.57-2.15-24.39-9.48-26.2-22.81-2.85-21,0-47.47,0-77.14V89.08c0-13.67-1.76-28.09,0-38.9,2.21-13.52,14.87-19.45,26.2-22.14C259.3,14,235.16-.94,213.21,11.27M770.79,253.43c25.48-4.13,47.45-24,52.4-51,3.84-20.93.67-48.59.67-74.46,0-23.55,1.24-47.91,0-68.42-1.38-22.76-17.32-40.06-31.57-48.3C775,1.3,746.86.68,719.06,1.88c-.62.72-2.48.21-2,2,25.51,8.45,49.05,24.51,51.73,58.36,1.54,19.53,0,43,0,65.74,0,23.12,1.72,47.29,0,66.41-2.47,27.4-21.13,45.31-37.63,53-4.81,2.24-10.35,2-14.1,5.36,19.65,1.26,37.71,3.27,53.74.67M637.1,107.2c0-16.65,1.78-33.8,0-49C633.5,27.39,607.75,4.29,574,1.88c-12.89-.92-31.84.16-44.34.67,5.38,5.05,12.54,5,18.14,8.05a65.1,65.1,0,0,1,33.58,53c4.09,56.9-3.62,133.31.68,189.84a453.9,453.9,0,0,0,55.08,0ZM328.76,242.7c4.13-2.92,12.18-10.48,16.12-16.1,14.93-21.29,10.75-60.87,10.75-98.61,0-26,2.75-57.37-1.35-77.14C348.51,23,322,4.25,293.15,1.88c-14.51-1.19-33.9-.14-45,1.34,23.33,8,48.2,25.22,51.73,53.67,2.56,20.73,0,46.54,0,71.1,0,25.41,2.87,50.59,0,71.78-3.18,23.39-20.86,39.9-38.29,47.63-4.26,1.88-9.12,2.57-12.77,5.36,28.46,3.56,62,2.56,79.95-10.06M60.71,3.22c-.41,0-.79.1-.67.67,36.8,9.54,56.06,36.59,53.07,85.87a444.93,444.93,0,0,0,54.41,0c9.21-70-37.73-96.93-106.81-86.54"/>
  </svg>
` }} />
</div>


export const AnimatedBox = props => {
  let isVisible = props.isVisible

  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (isVisible) setTimeout(() => { setAnimate(true) }, props.time)
  })

  return <div className='animated-box' style={{ marginTop: !animate ? 0 : -props.appState.itemSize }}>
    {props.children}
  </div>
}

/* class ShapeAnimated extends React.Component {
  state = {
    opacity: this.props.non ? 1 : 0
  }

  onChangeOpacityHandler = () => { this.setState(prevState => ({ opacity: prevState.opacity ? 0 : 1 })) }

  interval = null

  componentWillMount() {
    this.interval = setInterval(this.onChangeOpacityHandler, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    let { opacity } = this.state
    return <div style={{ height: '100%', width: '100%', opacity }}>
      <Shape {...this.props} />
    </div>
  }
}
 */

const mapStateToProps = state => ({
  appState: state.appState
})

export default connect(mapStateToProps)(Loading)